import React from "react";

import { Box, Text } from "@chakra-ui/react";

import { ReportFragment } from "../../../graphql/generated/definitions";
import { SectionWithAnswers } from "../types/ReportFormTypes";

import QuestionDispatchPrint from "./QuestionDispatchPrint";

type SectionPrintProps = {
  section: SectionWithAnswers;
  report: ReportFragment;
};

const SectionPrint: React.FC<SectionPrintProps> = ({ section, report }) => {
  return (
    <Box py="16">
      <Box className="avoid-break">
        <Text fontSize="2xl" color="black" fontWeight="semibold">
          {`${section.order + 1}`} - {section.title}
        </Text>
      </Box>
      {section.questions.map((question) => (
        <QuestionDispatchPrint
          key={question.id}
          question={question}
          report={report}
          sectionIndex={section.order + 1}
        />
      ))}
    </Box>
  );
};

export default SectionPrint;
